import { render, staticRenderFns } from "./gpuhubSyncView.vue?vue&type=template&id=3a022fb2&"
import script from "@/scripts/gpuHub/gpuhubSync/gpuhubSyncView.js?vue&type=script&lang=js&"
export * from "@/scripts/gpuHub/gpuhubSync/gpuhubSyncView.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports